import React from 'react';

const fmt = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

export default function CommercialPanel({ commercial }) {
  if (!commercial) return null;
  const fb = commercial.fare_breakdown || {};
  const keys = Object.keys(fb).filter((k) => fb[k] != null && fb[k] !== '');

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4" data-testid="commercial-panel">
      <p className="text-[10px] uppercase font-bold text-gray-500 mb-3">Commercial breakdown</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm mb-3">
        <div className="bg-gray-50 rounded-lg p-2">
          <p className="text-[10px] text-gray-500">Total collected</p>
          <p className="font-bold">{fmt(commercial.total_amount)}</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-2">
          <p className="text-[10px] text-gray-500">Supplier cost</p>
          <p className="font-bold">{fmt(commercial.supplier_total)}</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-2">
          <p className="text-[10px] text-gray-500">Markup</p>
          <p className="font-bold">{fmt(commercial.markup_amount)}</p>
        </div>
        {commercial.margin != null && (
          <div className="bg-emerald-50 rounded-lg p-2">
            <p className="text-[10px] text-emerald-700">Margin</p>
            <p className="font-bold text-emerald-900">{fmt(commercial.margin)}</p>
          </div>
        )}
        {commercial.airline_commission > 0 && (
          <div className="bg-violet-50 rounded-lg p-2">
            <p className="text-[10px] text-violet-700">Airline commission (TF−NF gross)</p>
            <p className="font-bold text-violet-900">{fmt(commercial.airline_commission)}</p>
          </div>
        )}
        {commercial.commission_accounting?.enabled && (
          <>
            <div className="bg-sky-50 rounded-lg p-2">
              <p className="text-[10px] text-sky-700">Agent share</p>
              <p className="font-bold text-sky-900">{fmt(commercial.commission_accounting.agent_commission_gross)}</p>
            </div>
            <div className="bg-emerald-50 rounded-lg p-2">
              <p className="text-[10px] text-emerald-700">ACF retained</p>
              <p className="font-bold text-emerald-900">{fmt(commercial.commission_accounting.acf_commission_retained_gross)}</p>
            </div>
          </>
        )}
      </div>
      {commercial.ssr_amount > 0 && (
        <p className="text-xs text-gray-600 mb-2">SSR add-ons: {fmt(commercial.ssr_amount)}</p>
      )}
      {keys.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
          {keys.map((k) => (
            <div key={k} className="bg-gray-50 rounded px-2 py-1">
              <span className="text-gray-500">{k.replace(/_/g, ' ')}</span>
              <span className="block font-medium">{typeof fb[k] === 'number' ? fmt(fb[k]) : String(fb[k])}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
